import React from 'react';
import { renderEvent } from './shared/renderers';

/**
 * EventBlock — rendu PARTAGÉ avec l'éditeur intranet (shared/renderers).
 * Dates formatées en français, image, lieu, description et CTA d'inscription.
 */
export default function EventBlock({ props = {}, theme }) {
  return renderEvent(props, theme);
}
